webpackJsonp([1],{

/***/ 101:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(101)
}
var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(112),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46f94841",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 111:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Button', {
    attrs: {
      "size": "small",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleImportBtnClick
    }
  }, [_vm._v("导入")]), _vm._v(" "), _c('input', {
    ref: "uploadInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.accept
    },
    on: {
      "change": _vm.handleFileChange
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex-container column"
  }, [_c('div', {
    staticClass: "item input border1"
  }, [_c('div', {
    staticClass: "border1"
  }, [_c('Row', [_c('div', {
    staticStyle: {
      "font-size": "18px",
      "color": "white",
      "background-color": "#2d8cf0"
    }
  }, [_vm._v("设置转化率 α")])]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v("起始值")]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v("最大值")]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v("间隔值")])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "6px"
    },
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Input-number', {
    attrs: {
      "size": "small",
      "step": 0.1
    },
    model: {
      value: (_vm.convRate.min),
      callback: function($$v) {
        _vm.$set(_vm.convRate, "min", $$v)
      },
      expression: "convRate.min"
    }
  })], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Input-number', {
    attrs: {
      "size": "small",
      "step": 0.1
    },
    model: {
      value: (_vm.convRate.max),
      callback: function($$v) {
        _vm.$set(_vm.convRate, "max", $$v)
      },
      expression: "convRate.max"
    }
  })], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Input-number', {
    attrs: {
      "size": "small",
      "step": 0.01
    },
    model: {
      value: (_vm.convRate.step),
      callback: function($$v) {
        _vm.$set(_vm.convRate, "step", $$v)
      },
      expression: "convRate.step"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "border1"
  }, [_c('Row', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('label', {
    attrs: {
      "for": "fa"
    }
  }, [_vm._v("机理方程")])]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "14"
    }
  }, [_c('Select', {
    attrs: {
      "id": "fa",
      "size": "small"
    },
    on: {
      "on-change": _vm.onSelectChange
    },
    model: {
      value: (_vm.reactionFunc),
      callback: function($$v) {
        _vm.reactionFunc = $$v
      },
      expression: "reactionFunc"
    }
  }, _vm._l((_vm.jilifuncs), function(item, index) {
    return _c('Option', {
      key: item.name,
      attrs: {
        "value": index
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('hr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMNInput),
      expression: "showMNInput"
    }],
    staticStyle: {
      "margin-top": "6px",
      "border": "1px solid lightblue"
    }
  }), _vm._v(" "), _c('Row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMNInput),
      expression: "showMNInput"
    }],
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "10",
      "offset": "2"
    }
  }, [_c('label', [_vm._v("n")]), _vm._v("  "), _c('Input-number', {
    staticStyle: {
      "margin-top": "-6px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.jilifuncValueN),
      callback: function($$v) {
        _vm.jilifuncValueN = $$v
      },
      expression: "jilifuncValueN"
    }
  })], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('label', [_vm._v("m")]), _vm._v("  "), _c('Input-number', {
    staticStyle: {
      "margin-top": "-6px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.jilifuncValueM),
      callback: function($$v) {
        _vm.jilifuncValueM = $$v
      },
      expression: "jilifuncValueM"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "border1",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('Row', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('label', {
    attrs: {
      "for": "ma"
    }
  }, [_vm._v("中间升温速率")])]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Input-number', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-6px"
    },
    attrs: {
      "id": "ma",
      "size": "small"
    },
    model: {
      value: (_vm.middleHeatRate),
      callback: function($$v) {
        _vm.middleHeatRate = $$v
      },
      expression: "middleHeatRate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "border1"
  }, [_c('Row', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "white",
      "background-color": "#2d8cf0"
    }
  }, [_vm._v("实验数据导入")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "margin-top": "6px"
    }
  }, [_vm._v("备注： 数据excel表格值依次为： 时间(min)， 温度(°C)， 重量(mg)， 重量微分(%/°C) ")]), _vm._v(" "), _vm._l((_vm.heatRates), function(item, index) {
    return _c('Row', {
      key: index,
      staticStyle: {
        "margin-top": "12px"
      },
      attrs: {
        "gutter": 4
      }
    }, [_c('i-col', {
      attrs: {
        "span": "6"
      }
    }, [_vm._v("升温速率")]), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": "6"
      }
    }, [_c('Input-number', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (item.heatRate),
        callback: function($$v) {
          _vm.$set(item, "heatRate", $$v)
        },
        expression: "item.heatRate"
      }
    })], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": "4"
      }
    }, [_c('Badge', {
      attrs: {
        "dot": "",
        "count": item.init ? '0' : '1'
      }
    }, [_c('xlsx-importer', {
      attrs: {
        "heatRate": item.heatRate
      },
      on: {
        "on-select-file": _vm.handleSelectedFile
      }
    })], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": "4"
      }
    }, [_c('Button', {
      attrs: {
        "size": "small",
        "disabled": _vm.heatRates.length <= 1
      },
      on: {
        "click": function($event) {
          return _vm.removeHeatingRate(index)
        }
      }
    }, [_vm._v("删除")])], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": "4"
      }
    }, [(index === _vm.heatRates.length - 1) ? _c('Button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": _vm.addHeatingRate
      }
    }, [_vm._v("增加")]) : _vm._e()], 1)], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0"
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": "24"
    }
  }, [_c('Tooltip', {
    attrs: {
      "content": "计算最佳机理方程"
    }
  }, [_c('Button', {
    attrs: {
      "disabled": _vm.disableCalculateJili,
      "size": "large",
      "type": "primary",
      "loading": _vm.loadingJili
    },
    on: {
      "click": _vm.calculateJili
    }
  }, [_vm._v("机理方程")])], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "disabled": _vm.disableCalculate,
      "size": "large",
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.calculate
    }
  }, [_vm._v("运        算")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item output border1"
  }, [_c('Tabs', {
    staticStyle: {
      "padding": "10px 15px"
    },
    attrs: {
      "animated": false
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "活化能"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsE0",
    attrs: {
      "options": _vm.e0Options
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "指前因子"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsPreFactor",
    attrs: {
      "options": _vm.preFactorOptions
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "TG"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsTg",
    attrs: {
      "options": _vm.tgOptions
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "DTG"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsDtg",
    attrs: {
      "options": _vm.dtgOptions
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "转化率"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsConvRate",
    attrs: {
      "options": _vm.convRateOptions
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "dα/dt-T"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsDadtT",
    attrs: {
      "options": _vm.dadttOptions
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "斜率图"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsDadt1T",
    attrs: {
      "options": _vm.dadt1tOptionsFM
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "斜率图"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsDadt1T",
    attrs: {
      "options": _vm.dadt1tOptionsFwo
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "斜率图"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsDadt1T",
    attrs: {
      "options": _vm.dadt1tOptionsKas
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "最佳机理方程"
    }
  }, [_c('div', {
    staticClass: "chart-container",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('b', [_vm._v("以Ea为准排序")]), _vm._v("  "), _c('Button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "small",
      "type": "dashed"
    },
    on: {
      "click": function($event) {
        return _vm.exportData(1)
      }
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('Scroll', [_c('Table', {
    ref: "table1",
    attrs: {
      "columns": _vm.columnsEa,
      "data": _vm.dataEa
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('b', [_vm._v("以LnA为准排序")]), _vm._v("  "), _c('Button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "small",
      "type": "dashed"
    },
    on: {
      "click": function($event) {
        return _vm.exportData(2)
      }
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('Scroll', [_c('Table', {
    ref: "table2",
    attrs: {
      "columns": _vm.columnsLnA,
      "data": _vm.dataLnA
    }
  })], 1)], 1)])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_vm._v("生物质及木材热分解动力学参数多模式可视化求解软件V1.0 "), _c('a', {
    staticClass: "readme",
    attrs: {
      "href": "https://pan.baidu.com/s/1smMwpOh",
      "target": "_blank"
    }
  }, [_vm._v("软件说明")])])
}]}

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "absolute",
      "height": "100%",
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('dashboard')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 46:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(115);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

function processRawData(rawData) {
  var len = rawData.length;
  var firstWeight = rawData[0].weight;
  var lastWeight = rawData[len - 1].weight;

  rawData.forEach(function (item) {
    var temp = item.temperature + 273.0;
    var weightP = item.weight / firstWeight * 100.0;
    var conversionRate = (firstWeight - item.weight) / (firstWeight - lastWeight);

    item['temperatureK'] = temp;
    item['weightP'] = weightP;
    item['conversionRate'] = conversionRate;
    item['dadt'] = 0;
  });
}

function processDadt(rawData) {
  var lastIdx = rawData.length - 1;
  if (lastIdx < 1) {
    window.console.log('rawData length < 2, do nothing');
    return;
  }

  var currentItem = void 0,
      nextItem = void 0;
  for (var i = 0; i < lastIdx; ++i) {
    currentItem = rawData[i];
    nextItem = rawData[i + 1];
    currentItem.dadt = (nextItem.conversionRate - currentItem.conversionRate) / (nextItem.time - currentItem.time);
  }

  rawData[lastIdx].dadt = rawData[lastIdx - 1].dadt;
}

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    heatRates: [{
      heatRate: 1, init: false, rawData: []
    }, {
      heatRate: 5, init: false, rawData: []
    }, {
      heatRate: 10, init: false, rawData: []
    }, {
      heatRate: 15, init: false, rawData: []
    }, {
      heatRate: 20, init: false, rawData: []
    }]
  },
  mutations: {
    ADD_HEAT_RATE: function ADD_HEAT_RATE(state) {
      state.heatRates.push({ heatRate: null, init: false, rawData: [] });
    },
    REMOVE_HEAT_RATE: function REMOVE_HEAT_RATE(state, heatRate) {
      // const heatRates = state.heatRates;
      // state.heatRates = heatRates.filter( item => item.heatRate !== heatRate);
      state.heatRates.splice(heatRate, 1);
    },
    UPDATE_HEATING_RATE_RAW_DATA: function UPDATE_HEATING_RATE_RAW_DATA(state, convertedData) {
      convertedData.body.shift();
      state.heatRates.forEach(function (item) {
        if (item.heatRate && item.heatRate === convertedData.heatRate) {
          var tempDatas = [];
          convertedData.body.forEach(function (data) {
            tempDatas.push({
              time: parseFloat(data.time),
              temperature: parseFloat(data.temperature),
              weight: parseFloat(data.weight),
              dWeight: parseFloat(data.dWeight)
            });
          });

          processRawData(tempDatas);
          processDadt(tempDatas);

          item.rawData = tempDatas;
          item.init = true;
        }
      });
    }
  },
  actions: {
    AddHeatRate: function AddHeatRate(_ref) {
      var commit = _ref.commit;

      commit('ADD_HEAT_RATE');
    },
    RemoveHeatRate: function RemoveHeatRate(_ref2, heatRate) {
      var commit = _ref2.commit;

      commit('REMOVE_HEAT_RATE', heatRate);
    },
    UpdateHeatingRateRawData: function UpdateHeatingRateRawData(_ref3, convertedData) {
      var commit = _ref3.commit;

      commit('UPDATE_HEATING_RATE_RAW_DATA', convertedData);
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(102)
}
var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(113),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dashboard__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_dashboard__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    dashboard: __WEBPACK_IMPORTED_MODULE_0__components_dashboard___default.a
  },
  data: function data() {
    return {
      seller: {}
    };
  }
});

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log10__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xlsx_importer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xlsx_importer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__xlsx_importer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equation__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__calculate__ = __webpack_require__(58);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var B1 = 0.4567;
var CONST_R = 8.314;
var KNOWN_REACTION_LEVEL_FUN_IDX = 40;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  components: { xlsxImporter: __WEBPACK_IMPORTED_MODULE_2__xlsx_importer___default.a },
  data: function data() {
    return {
      showMNInput: false,
      jilifuncValueN: 1,
      jilifuncValueM: 0,
      disableCalculate: false,
      disableCalculateJili: false,
      dataEa: [],
      dataLnA: [],
      columnsEa: [{ title: '升温速率', key: 'heatRate' }, { title: '机理函数', key: 'name' }, { title: '误差', key: 'error' }],
      columnsLnA: [{ title: '升温速率', key: 'heatRate' }, { title: '机理函数', key: 'name' }, { title: '误差', key: 'error' }],
      loading: false,
      loadingJili: false,
      jilifuncs: __WEBPACK_IMPORTED_MODULE_3__equation__["a" /* default */].mechanisms,
      convRate: { min: 0.2, max: 0.8, step: 0.05 },
      reactionFunc: 32,
      middleHeatRate: 10,
      heatRates: this.$store.state.heatRates,
      e0Options: __WEBPACK_IMPORTED_MODULE_3__equation__["a" /* default */].default_high_charts_option,
      tgOptions: __WEBPACK_IMPORTED_MODULE_3__equation__["a" /* default */].default_high_charts_option,
      dtgOptions: __WEBPACK_IMPORTED_MODULE_3__equation__["a" /* default */].default_high_charts_option,
      convRateOptions: __WEBPACK_IMPORTED_MODULE_3__equation__["a" /* default */].default_high_charts_option,
      dadttOptions: __WEBPACK_IMPORTED_MODULE_3__equation__["a" /* default */].default_high_charts_option,
      dadt1tOptionsFM: __WEBPACK_IMPORTED_MODULE_3__equation__["a" /* default */].default_high_charts_option,
      dadt1tOptionsFwo: __WEBPACK_IMPORTED_MODULE_3__equation__["a" /* default */].default_high_charts_option,
      dadt1tOptionsKas: __WEBPACK_IMPORTED_MODULE_3__equation__["a" /* default */].default_high_charts_option,
      preFactorOptions: __WEBPACK_IMPORTED_MODULE_3__equation__["a" /* default */].default_high_charts_option
    };
  },

  methods: {
    onSelectChange: function onSelectChange(val) {
      if (val > KNOWN_REACTION_LEVEL_FUN_IDX) {
        this.showMNInput = true;
      } else {
        this.showMNInput = false;
      }
    },
    exportData: function exportData(type) {
      if (type === 1) {
        this.$refs.table1.exportCsv({
          filename: 'Ea',
          columns: this.columnsEa,
          data: this.dataEa
        });
      } else if (type === 2) {
        this.$refs.table2.exportCsv({
          filename: 'lnA',
          columns: this.columnsLnA,
          data: this.dataLnA
        });
      }
    },
    addHeatingRate: function addHeatingRate() {
      var _this = this;

      this.$store.dispatch('AddHeatRate').then(function () {
        _this.$Message.info('添加升温速率成功');
      }).catch(function () {
        _this.$Message.info('添加升温速率失败');
      });
    },
    removeHeatingRate: function removeHeatingRate(heatRate) {
      var _this2 = this;

      this.$store.dispatch('RemoveHeatRate', heatRate).then(function () {
        _this2.$Message.info('删除升温速率成功');
      }).catch(function () {
        _this2.$Message.info('删除升温速率失败');
      });
    },
    handleSelectedFile: function handleSelectedFile(convertedData) {
      var _this3 = this;

      this.$store.dispatch('UpdateHeatingRateRawData', convertedData).then(function () {
        _this3.$Message.info('导入升温速率数据成功');
      }).catch(function () {
        _this3.$Message.error('导入升温速率数据失败');
      });
    },
    calculateErFwo: function calculateErFwo(convRate, e, kDadtes, precision) {
      var slopDataes = [];
      kDadtes.map(function (item) {
        var x = 1000 / item.data.temperatureK;
        var hx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__calculate__["a" /* calculateHxFwo */])(e, item.data.temperatureK);
        var y = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log10___default()(item.heatRate) / hx;
        slopDataes.push([x, y]);
      });

      var line = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__calculate__["b" /* fitLine */])(slopDataes);
      var er = -CONST_R * line.a * 1000 / B1;
      var v = Math.abs(er - e) / e;
      if (!v) {
        return er;
      }
      console.log(v);
      if (v < precision) {
        return er;
      } else {
        return this.calculateErFwo(convRate, er, kDadtes, precision);
      }
    },
    calculateErKas: function calculateErKas(convRate, e, kDadtes) {
      var slopDataes = [];
      kDadtes.map(function (item) {
        var x = 1000 / item.data.temperatureK;
        var hx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__calculate__["c" /* calculateHxKas */])(e, item.data.temperatureK);
        var phtt = item.heatRate / (hx * Math.pow(item.data.temperatureK, 2));
        var y = Math.log(phtt);
        slopDataes.push([x, y]);
      });

      var line = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__calculate__["b" /* fitLine */])(slopDataes);
      var er = -CONST_R * line.a * 1000;
      var v = Math.abs(er - e) / e;
      if (v < 0.01) {
        return er;
      } else {
        return this.calculateErKas(convRate, er, kDadtes);
      }
    },
    handleCal: function handleCal() {
      var _this4 = this;

      var tgSeries = [];
      var dtgSeries = [];
      var conversionRateSeries = [];
      var dadtSeries = [];

      this.heatRates.map(function (item) {
        var tgSeriesData = [];
        var dtgSeriesData = [];
        var convRateSeriesData = [];
        var dadtSeriesData = [];

        item.rawData.map(function (rItem) {
          tgSeriesData.push([rItem.temperature, rItem.weightP]);
          dtgSeriesData.push([rItem.temperature, rItem.dWeight]);
          convRateSeriesData.push([rItem.temperature, rItem.conversionRate]);
          dadtSeriesData.push([rItem.temperature, rItem.dadt]);
        });

        tgSeries.push({ name: item.heatRate + '℃/min', data: tgSeriesData });
        dtgSeries.push({ name: item.heatRate + '℃/min', data: dtgSeriesData });
        conversionRateSeries.push({ name: item.heatRate + '℃/min', data: convRateSeriesData });
        dadtSeries.push({ name: item.heatRate + '℃/min', data: dadtSeriesData });
      });

      var dadt_1_TSeriesFM = []; //dα/dt-1/T图
      var dadt_1_TSeriesFwo = []; //dα/dt-1/T图
      var dadt_1_TSeriesKas = []; //dα/dt-1/T图

      var erxAxisData = [];
      var erSeriesDataFwo = [];
      var erSeriesDataKas = [];
      var e0SeriesDataFM = [];

      var lnASeriesDataFwo = [];
      var lnASeriesDataKas = [];
      var lnASeriesDataFM = [];

      var lineBDatasFM = []; //Friedman截距

      for (var convRate = this.convRate.min; convRate <= this.convRate.max; convRate += this.convRate.step) {
        var kDadtes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__calculate__["d" /* fetchNearestRateDatasForFixedRate */])(this.heatRates, convRate);
        var fixedConvRate = convRate.toFixed(3);
        erxAxisData.push(fixedConvRate);
        var middleRawData = null;
        kDadtes.map(function (item) {
          if (item.heatRate === _this4.middleHeatRate) {
            middleRawData = item.data;
          }
        });
        if (middleRawData === null) {
          this.$Message.error('中间升温速率错误！');
          return;
        }

        //Friedman
        var slopDataesFM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__calculate__["e" /* fetchFMSlopDatasForFixedRate */])(kDadtes);
        dadt_1_TSeriesFM.push({ name: fixedConvRate, data: slopDataesFM });
        var lineFM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__calculate__["b" /* fitLine */])(slopDataesFM);
        e0SeriesDataFM.push(-lineFM.a * CONST_R); //这里不乘以1000，因为纵坐标单位为KJ/mol
        lnASeriesDataFM.push(lineFM.b - Math.log(this.jilifuncs[this.reactionFunc].diff(convRate, this.jilifuncValueM, this.jilifuncValueN)));
        lineBDatasFM.push(lineFM.b);

        //机理方程积分形式g(a)
        var temp1Kas = this.jilifuncs[this.reactionFunc].integ(convRate, this.jilifuncValueM, this.jilifuncValueN);
        //FWO
        var slopDataesFwo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__calculate__["f" /* fetchFwoSlopDatasForFixedRate */])(kDadtes);
        dadt_1_TSeriesFwo.push({ name: fixedConvRate, data: slopDataesFwo });
        var lineFwo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__calculate__["b" /* fitLine */])(slopDataesFwo);
        var e0Fwo = -CONST_R * lineFwo.a * 1000 / B1;
        var erFwo = this.calculateErFwo(convRate, e0Fwo, kDadtes, 0.01);
        if (!erFwo) {
          erFwo = this.calculateErFwo(convRate, e0Fwo, kDadtes, 0.05);
        }
        if (!erFwo) {
          erFwo = this.calculateErFwo(convRate, e0Fwo, kDadtes, 0.1);
        }

        erSeriesDataFwo.push(erFwo / 1000);
        var tempFwo = this.middleHeatRate * CONST_R * temp1Kas / erFwo;
        var logAFwo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_log10___default()(tempFwo) + 2.315 + B1 * erFwo / (CONST_R * middleRawData.temperatureK);
        var lnAFwo = logAFwo * Math.log(10);
        lnASeriesDataFwo.push(lnAFwo);

        //KAS
        var slopDataesKas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__calculate__["g" /* fetchKasSlopDatasForFixedRate */])(kDadtes);
        dadt_1_TSeriesKas.push({ name: fixedConvRate, data: slopDataesKas });
        var lineKas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__calculate__["b" /* fitLine */])(slopDataesKas);
        var e0Kas = -CONST_R * lineKas.a * 1000;
        var erKas = this.calculateErKas(convRate, e0Kas, kDadtes);
        erSeriesDataKas.push(erKas / 1000);
        var temp0Kas = Math.pow(middleRawData.temperatureK, 2);
        var lnAKas = Math.log(this.middleHeatRate / temp0Kas) + erKas / (CONST_R * middleRawData.temperatureK) - Math.log(erKas / (CONST_R * temp1Kas));
        lnASeriesDataKas.push(lnAKas);
      }

      window.console.log(erSeriesDataFwo);
      window.console.log(erSeriesDataKas);
      window.console.log(e0SeriesDataFM);

      this.tgOptions = this.generateOption('TG图', '温度(°C)', '重量(%)', tgSeries);

      this.dtgOptions = this.generateOption('DTG图', '温度(°C)', '重量微分(%/°C)', dtgSeries);
      this.convRateOptions = this.generateOption('转化率', '温度(°C)', '转化率', conversionRateSeries);
      this.dadttOptions = this.generateOption('dα/dt-T图', '温度(°C)', 'dα/dt', dadtSeries);
      this.dadt1tOptionsFM = this.generateOption('Friedman斜率图', '1000/T', 'Log(β)', dadt_1_TSeriesFM);
      this.dadt1tOptionsFwo = this.generateOption('FWO斜率图', '1000/T', 'Log(β)', dadt_1_TSeriesFwo);
      this.dadt1tOptionsKas = this.generateOption('KAS斜率图', '1000/T', 'Log(β)', dadt_1_TSeriesKas);

      this.e0Options = this.generateE0Option(erxAxisData, [{ name: 'FWO', data: erSeriesDataFwo }, { name: 'KAS', data: erSeriesDataKas }, { name: 'Friedman', data: e0SeriesDataFM }]);

      var nLnAnFM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__calculate__["h" /* calculateLnAandNForFuntion43 */])(erxAxisData, lineBDatasFM, erxAxisData.length);
      var subTitle = 'Friedman 机理方程编号43拟合出的n=' + nLnAnFM.a + ', ln(A)值=' + nLnAnFM.b;
      this.preFactorOptions = this.generateLnAOption(subTitle, erxAxisData, [{
        name: 'FWO-lnA',
        data: lnASeriesDataFwo
      }, {
        name: 'KAS-lnA',
        data: lnASeriesDataKas
      }, {
        name: 'Friedman-lnA',
        data: lnASeriesDataFM
      }]);
    },
    calculate: function calculate() {
      var _this5 = this;

      for (var i = 0; i < this.heatRates.length; ++i) {
        if (!this.heatRates[i].init) {
          this.$Modal.info({
            title: '实验数据未导入'
          });
          return;
        }
      }

      this.loading = true;
      this.disableCalculateJili = true;
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var self_ = _this5;
        setTimeout(function () {
          try {
            self_.handleCal();
            resolve();
          } catch (e) {
            window.console.log(e);
            reject(e);
          }
        }, 500);
      }).then(function () {
        _this5.$Message.success('计算完成');
        _this5.loading = false;
        _this5.disableCalculateJili = false;
      }).catch(function (e) {
        _this5.loading = false;
        _this5.disableCalculateJili = false;
        window.console.log(e);
        _this5.$Modal.error({
          title: '运算失败',
          content: e.toString()
        });
      }).finally(function () {
        _this5.loading = false;
        _this5.disableCalculateJili = false;
      });
    },
    handleCalJili: function handleCalJili() {
      var _this6 = this;

      this.dataEa = [];
      this.dataLnA = [];

      this.heatRates.map(function (item) {
        var result = _this6.handleCalJiliForOneHeatRate(item);

        var tempEa = _this6.dataEa.concat(result.absEaData);
        var tempLnA = _this6.dataLnA.concat(result.absLnAData);
        _this6.dataEa = tempEa;
        _this6.dataLnA = tempLnA;
      });

      window.console.log(this.dataEa);
      window.console.log(this.dataLnA);
    },
    handleCalJiliForOneHeatRate: function handleCalJiliForOneHeatRate(item) {
      var convDadtes = [];
      var currentHeatRate = void 0;
      for (var convRate = this.convRate.min; convRate <= this.convRate.max; convRate += this.convRate.step) {
        //          let kDadtes = fetchNearestRateDatasForFixedRate(this.heatRates, convRate);
        var rateData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__calculate__["i" /* nearestRateData */])(item.rawData, convRate);

        var temperateK = rateData.temperatureK;
        var dadt = rateData.dadt;
        var revertTempK = 1.0 / temperateK;
        var temp = Math.pow(temperateK, 2);

        currentHeatRate = item.heatRate;
        convDadtes.push({ convRate: convRate, dadt: dadt, revertTempK: revertTempK, temp: temp });
      }

      var absEaDatas = [];
      var absLnADatas = [];
      __WEBPACK_IMPORTED_MODULE_3__equation__["a" /* default */].mechanisms.map(function (mechanism, index) {
        if (index > KNOWN_REACTION_LEVEL_FUN_IDX) {
          return;
        }
        var redfernDatas = [];
        var acharDatas = [];
        convDadtes.map(function (item) {
          var ga = mechanism.integ(item.convRate);
          var fa = mechanism.diff(item.convRate);

          var redfern = Math.log(ga / item.temp);
          var achar = Math.log(1.0 / fa * item.dadt);

          redfernDatas.push([item.revertTempK, redfern]);
          acharDatas.push([item.revertTempK, achar]);
        });

        var redfernLine = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__calculate__["b" /* fitLine */])(redfernDatas);
        var acharLine = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__calculate__["b" /* fitLine */])(acharDatas);

        var coatsRedfernEa = -redfernLine.a * CONST_R;
        var coatsRedfernLnA = redfernLine.b + Math.log(currentHeatRate * coatsRedfernEa) - Math.log(CONST_R);

        var acharBridlySharpEa = -acharLine.a * CONST_R;
        var acharBridlySharpLnA = acharLine.b + Math.log(currentHeatRate);

        var absEa = Math.abs(coatsRedfernEa - acharBridlySharpEa);
        var absLnA = Math.abs(coatsRedfernLnA - acharBridlySharpLnA);

        absEaDatas.push({ heatRate: currentHeatRate, error: absEa, name: mechanism.name });
        absLnADatas.push({ heatRate: currentHeatRate, error: absLnA, name: mechanism.name });
      });

      absEaDatas.sort(function (a, b) {
        return a.error - b.error;
      });
      absLnADatas.sort(function (a, b) {
        return a.error - b.error;
      });

      return { absEaData: absEaDatas.slice(0, 5), absLnAData: absLnADatas.slice(0, 5) };
    },
    calculateJili: function calculateJili() {
      var _this7 = this;

      for (var i = 0; i < this.heatRates.length; ++i) {
        if (!this.heatRates[i].init) {
          this.$Message.error('数据未初始化');
          return;
        }
      }

      this.loadingJili = true;
      this.disableCalculate = true;
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var self_ = _this7;
        setTimeout(function () {
          try {
            self_.handleCalJili();
            resolve();
          } catch (e) {
            reject(e);
          }
        }, 500);
      }).then(function () {
        _this7.$Message.success('计算完成');
        _this7.loadingJili = false;
        _this7.disableCalculate = false;
      }).catch(function (e) {
        window.console.log(e);
        _this7.$Modal.error({
          title: '运算失败',
          content: e.toString()
        });
      }).finally(function () {
        _this7.loadingJili = false;
        _this7.disableCalculate = false;
      });
    },
    generateE0Option: function generateE0Option(xCategories, seriesData) {
      var opt = {
        title: {
          text: '活化能E'
        },
        xAxis: {
          title: {
            text: '转化率'
          },
          categories: xCategories
        },
        credits: {
          enabled: false
        },
        yAxis: {
          title: {
            text: '活化能(KJ/mol)'
          }
        },
        series: seriesData
      };

      return opt;
    },
    generateLnAOption: function generateLnAOption(subTitle, xCategories, seriesData) {
      var opt = {
        title: {
          text: '指前因子A'
        },
        subtitle: {
          text: subTitle
        },
        xAxis: {
          title: {
            text: '转化率'
          },
          categories: xCategories
        },
        credits: {
          enabled: false
        },
        yAxis: {
          title: {
            text: '指前因子对数(min-1)'
          }
        },
        series: seriesData
      };

      return opt;
    },
    generateOption: function generateOption(title, xTitle, yTitle, seriesData) {
      var opt = {
        chart: {
          type: 'spline'
        },
        title: {
          text: title
        },
        subtitle: {
          text: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          title: {
            text: xTitle
          }
        },
        yAxis: {
          title: {
            text: yTitle
          }
        },
        tooltip: {
          headerFormat: '<b>{series.name}</b><br>',
          pointFormat: '{point.x:.2f}: {point.y:.2f}'
        },
        plotOptions: {
          series: {
            events: {
              legendItemClick: function legendItemClick() {
                return false;
              }
            }
          }
        },
        series: seriesData || []
      };

      return opt;
    },
    handleAuthor: function handleAuthor() {
      this.$Modal.info({
        title: '',
        content: '<p style="text-align: left">本软件由中国林业科学研究院木材工业研究所博士后，北京林业大学副教授漆楚生研发，联系邮箱：qichusheng@bjfu.edu.cn</p>'
      });
    }
  }
});

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xlsx__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xlsx__);


//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'xlsx-importer',
  data: function data() {
    return {
      loading: false
    };
  },

  props: {
    accept: {
      type: String,
      default: '.xlsx, .xls'
    },
    heatRate: Number
  },
  methods: {
    handleImportBtnClick: function handleImportBtnClick() {
      if (!this.heatRate) {
        this.$Message.warning('请先填写相应的升温速率');
        return;
      }

      this.$refs.uploadInput.value = null;
      this.$refs.uploadInput.click();
    },
    handleFileChange: function handleFileChange(e) {
      var _this = this;

      var files = e.target.files;
      if (!files || files.length === 0) return;

      var rawFile = files[0];
      this.loading = true;
      this.fileConvertToWorkbook(rawFile).then(function (workbook) {
        _this.loading = false;
        var opts = { header: ['time', 'temperature', 'weight', 'dWeight'] };

        var xlsxArr = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], opts);
        _this.dispatchData(_this.parseXLSXData(xlsxArr));
      }).catch(function (err) {
        _this.loading = false;
        _this.$Message.error('导出使用数据出错， 请检查错误信息');
        window.console.error(err);
      });
    },
    fileConvertToWorkbook: function fileConvertToWorkbook(file) {
      var reader = new FileReader();

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        try {
          reader.onload = function (e) {
            var data = e.target.result;
            resolve(__WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.read(data, { type: 'binary' }));
          };

          reader.onerror = function (error) {
            reject(error);
          };

          reader.readAsBinaryString(file);
        } catch (error) {
          reject(error);
        }
      });
    },
    parseXLSXData: function parseXLSXData(xlsxArr) {
      var tableArr = [];
      var length = 0,
          maxLength = 0,
          maxLengthIndex = 0;

      xlsxArr.forEach(function (item, index) {
        length = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item).length;
        if (maxLength < length) {
          maxLength = length;
          maxLengthIndex = index;
        }
      });

      var tableHeader = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(xlsxArr[maxLengthIndex]);
      var rowData = {};
      xlsxArr.forEach(function (item) {
        rowData = {};
        for (var i = 0; i < maxLength; i++) {
          rowData[tableHeader[i]] = item[tableHeader[i]] || '';
        }
        tableArr.push(rowData);
      });

      return { header: tableHeader, data: tableArr };
    },
    dispatchData: function dispatchData(_ref) {
      var header = _ref.header,
          data = _ref.data;

      var excelData = { heatRate: this.heatRate, header: header, body: data };
      this.$emit('on-select-file', excelData);
    }
  }
});

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchNearestRateDatasForFixedRate;
/* harmony export (immutable) */ __webpack_exports__["f"] = fetchFwoSlopDatasForFixedRate;
/* harmony export (immutable) */ __webpack_exports__["i"] = nearestRateData;
/* harmony export (immutable) */ __webpack_exports__["g"] = fetchKasSlopDatasForFixedRate;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchFMSlopDatasForFixedRate;
/* harmony export (immutable) */ __webpack_exports__["h"] = calculateLnAandNForFuntion43;
/* harmony export (immutable) */ __webpack_exports__["b"] = fitLine;
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateHxFwo;
/* harmony export (immutable) */ __webpack_exports__["c"] = calculateHxKas;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log10__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log10__);

function fetchNearestRateDatasForFixedRate(heatRates, convRate) {
  var rateDatas = [];
  heatRates.forEach(function (item) {
    var rateData = nearestRateData(item.rawData, convRate);
    rateDatas.push({ heatRate: item.heatRate, data: rateData });
  });

  return rateDatas;
}

function fetchFwoSlopDatasForFixedRate(arr) {
  var result = [];
  arr.forEach(function (item) {
    result.push([1000 / item.data.temperatureK, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log10___default()(item.heatRate)]);
  });

  return result;
}

function nearestRateData(arr, rate) {
  var newArr = arr.slice(0);
  newArr.sort(function (a, b) {
    return Math.abs(a.conversionRate - rate) - Math.abs(b.conversionRate - rate);
  });

  var result = newArr[0];
  newArr.splice(0, newArr.length);
  return result;
}

function fetchKasSlopDatasForFixedRate(arr) {
  var result = [];
  arr.forEach(function (item) {
    var ptt = item.heatRate / Math.pow(item.data.temperatureK, 2);
    result.push([1000 / item.data.temperatureK, Math.log(ptt)]);
  });

  return result;
}

function fetchFMSlopDatasForFixedRate(arr) {
  var result = [];
  arr.forEach(function (item) {
    result.push([1000 / item.data.temperatureK, Math.log(item.data.dadt)]);
  });

  return result;
}

function calculateLnAandNForFuntion43(xArr, yArr, len) {
  var newArr = [];

  for (var i = 0; i < len; i++) {
    newArr.push([Math.log(1 - xArr[i]), yArr[i]]);
  }

  return fitLine(newArr);
}

function fitLine(arr) {
  /*y = Ax + B，根据最小二乘法求出A，B*/
  var a = void 0,
      b = void 0;
  var len = arr.length;
  var xmean = 0.0,
      ymean = 0.0;
  arr.map(function (item) {
    xmean += item[0];
    ymean += item[1];
  });

  xmean /= len;
  ymean /= len;

  var sumx2 = 0.0,
      sumxy = 0.0;

  arr.map(function (item) {
    var temp = item[0] - xmean;
    sumx2 += temp * temp;
    sumxy += (item[1] - ymean) * temp;
  });

  a = sumxy / sumx2;
  b = ymean - a * xmean;

  return { a: a, b: b };
}

function calculateHxFwo(e, kVal) {
  var x = e / (8.314 * kVal);
  var hx = (Math.pow(x, 4) + 18 * Math.pow(x, 3) + 86 * Math.pow(x, 2) + 96 * x) / (Math.pow(x, 4) + 20 * Math.pow(x, 3) + 120 * Math.pow(x, 2) + 240 * x + 120);
  var px = Math.exp(-x) / Math.pow(x, 2) * hx;

  return px / (0.0048 * Math.exp(-1.0516 * x));
}

function calculateHxKas(e, kVal) {
  var x = e / (8.314 * kVal);
  var hx = (Math.pow(x, 4) + 18 * Math.pow(x, 3) + 86 * Math.pow(x, 2) + 96 * x) / (Math.pow(x, 4) + 20 * Math.pow(x, 3) + 120 * Math.pow(x, 2) + 240 * x + 120);

  return hx;
}

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function minusSqrt(a) {
  return Math.pow(1 - a, 0.5);
}

function minusRevertTriple(a) {
  return Math.pow(1 - a, 1 / 3);
}

function minus2RevertTriple(a) {
  return Math.pow(1 - a, 2 / 3);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mechanisms: [{
    name: '1 抛物线法则',
    integ: function integ(a) {
      return a * a;
    },
    diff: function diff(a) {
      return Math.pow(a, -1) / 2.0;
    }
  }, {
    name: '2 Valensi方程',
    integ: function integ(a) {
      var t = 1 - a;
      return a + t * Math.log(t);
    },
    diff: function diff(a) {
      var t = -Math.log(1 - a);
      return Math.pow(t, -1);
    }
  }, {
    name: '3 Jander方程,2D,n=0.5',
    integ: function integ(a) {
      return minusSqrt(minusSqrt(a));
    },
    diff: function diff(a) {
      return 4 * minusSqrt(a) * minusSqrt(minusSqrt(a));
    }
  }, {
    name: '4 Jander方程,2D,n=2',
    integ: function integ(a) {
      return Math.pow(1 - minusSqrt(a), 2);
    },
    diff: function diff(a) {
      return minusSqrt(a) * Math.pow(1 - minusSqrt(a), -1);
    }
  }, {
    name: '5 Jander方程,3D,n=0.5',
    integ: function integ(a) {
      var temp = minusRevertTriple(a);
      return minusSqrt(temp);
    },
    diff: function diff(a) {
      var temp = minusRevertTriple(a);
      return 6 * minus2RevertTriple(a) * minusSqrt(temp);
    }
  }, {
    name: '6 Jander方程,3D,n=2',
    integ: function integ(a) {
      return Math.pow(1 - minusRevertTriple(a), 2);
    },
    diff: function diff(a) {
      return 3 / 2 * minus2RevertTriple(a) * Math.pow(1 - minusRevertTriple(a), -1);
    }
  }, {
    name: '7 G.-B方程 3D',
    integ: function integ(a) {
      return 1 - 2 / 3 * a - minus2RevertTriple(a);
    },
    diff: function diff(a) {
      var temp = Math.pow(1 - a, -1 / 3);
      return 3 / 2 * Math.pow(temp - 1, -1);
    }
  }, {
    name: '8 反Jander方程 3D',
    integ: function integ(a) {
      var temp = Math.pow(1 + a, 1 / 3);
      return Math.pow(temp - 1, 2);
    },
    diff: function diff(a) {
      var temp = Math.pow(1 + a, 1 / 3);
      return 1.5 * Math.pow(1 + a, 2 / 3) * Math.pow(temp - 1, -1);
    }
  }, {
    name: '9 Z.-L.-T.方程 3D',
    integ: function integ(a) {
      var temp = Math.pow(1 - a, -1 / 3);
      return Math.pow(temp - 1, 2);
    },
    diff: function diff(a) {
      var temp = Math.pow(1 - a, -1 / 3);
      return 1.5 * Math.pow(1 - a, 4 / 3) * Math.pow(temp - 1, -1);
    }
  }, {
    name: '10 Avrami-Erofeev方程 n=1/4,m=4',
    integ: function integ(a) {
      return Math.pow(-Math.log(1 - a), 1 / 4);
    },
    diff: function diff(a) {
      return 4 * (1 - a) * Math.pow(-Math.log(1 - a), 3 / 4);
    }
  }, {
    name: '11 Avrami-Erofeev方程 n=1/3,m=3',
    integ: function integ(a) {
      return Math.pow(-Math.log(1 - a), 1 / 3);
    },
    diff: function diff(a) {
      return 3 * (1 - a) * Math.pow(-Math.log(1 - a), 2 / 3);
    }
  }, {
    name: '12 Avrami-Erofeev方程 n=2/5',
    integ: function integ(a) {
      return Math.pow(-Math.log(1 - a), 2 / 5);
    },
    diff: function diff(a) {
      return 2.5 * (1 - a) * Math.pow(-Math.log(1 - a), 3 / 5);
    }
  }, {
    name: '13 Avrami-Erofeev方程 n=0.5,m=2',
    integ: function integ(a) {
      return Math.pow(-Math.log(1 - a), 0.5);
    },
    diff: function diff(a) {
      return 2 * (1 - a) * Math.pow(-Math.log(1 - a), 0.5);
    }
  }, {
    name: '14 Avrami-Erofeev方程 n=2/3',
    integ: function integ(a) {
      return Math.pow(-Math.log(1 - a), 2 / 3);
    },
    diff: function diff(a) {
      return 1.5 * (1 - a) * Math.pow(-Math.log(1 - a), 1 / 3);
    }
  }, {
    name: '15 Avrami-Erofeev方程 n=3/4',
    integ: function integ(a) {
      return Math.pow(-Math.log(1 - a), 3 / 4);
    },
    diff: function diff(a) {
      return 4 / 3 * (1 - a) * Math.pow(-Math.log(1 - a), 1 / 4);
    }
  }, {
    name: '16 Mample单行法则',
    integ: function integ(a) {
      return -Math.log(1 - a);
    },
    diff: function diff(a) {
      return 1 - a;
    }
  }, {
    name: '17 Avrami-Erofeev方程 n=3/2',
    integ: function integ(a) {
      return Math.pow(-Math.log(1 - a), 3 / 2);
    },
    diff: function diff(a) {
      return 2 / 3 * (1 - a) * Math.pow(-Math.log(1 - a), 1 / 2);
    }
  }, {
    name: '18 Avrami-Erofeev方程 n=2',
    integ: function integ(a) {
      return Math.pow(-Math.log(1 - a), 2);
    },
    diff: function diff(a) {
      return 0.5 * (1 - a) * Math.pow(-Math.log(1 - a), -1);
    }
  }, {
    name: '19 Avrami-Erofeev方程 n=3',
    integ: function integ(a) {
      return Math.pow(-Math.log(1 - a), 3);
    },
    diff: function diff(a) {
      return 1 / 3 * (1 - a) * Math.pow(-Math.log(1 - a), -2);
    }
  }, {
    name: '20 Avrami-Erofeev方程 n=4',
    integ: function integ(a) {
      return Math.pow(-Math.log(1 - a), 4);
    },
    diff: function diff(a) {
      return 1 / 4 * (1 - a) * Math.pow(-Math.log(1 - a), -3);
    }
  }, {
    name: '21 P.-T.方程(***)',
    integ: function integ(a) {
      return Math.log(a / (1 - a));
    },
    diff: function diff(a) {
      return a * (1 - a);
    }
  }, {
    name: '22 Mampel Power法则 n=1/4',
    integ: function integ(a) {
      return Math.pow(a, 1 / 4);
    },
    diff: function diff(a) {
      return 4 * Math.pow(a, 3 / 4);
    }
  }, {
    name: '23 Mampel Power法则 n=1/3',
    integ: function integ(a) {
      return Math.pow(a, 1 / 3);
    },
    diff: function diff(a) {
      return Math.pow(a, 2 / 3) * 3;
    }
  }, {
    name: '24 Mampel Power法则 n=1/2',
    integ: function integ(a) {
      return Math.pow(a, 1 / 2);
    },
    diff: function diff(a) {
      return Math.pow(a, 1 / 2) * 2;
    }
  }, {
    name: '25 Mampel Power法则 n=1',
    integ: function integ(a) {
      return a;
    },
    diff: function diff(a) {
      return 1.0;
    }
  }, {
    name: '26 Mampel Power法则 n=3/2',
    integ: function integ(a) {
      return Math.pow(a, 3 / 2);
    },
    diff: function diff(a) {
      return Math.pow(a, 1 / 2) * 2 / 3;
    }
  }, {
    name: '27 Mampel Power法则 n=2',
    integ: function integ(a) {
      return Math.pow(a, 2);
    },
    diff: function diff(a) {
      return 0.5 * Math.pow(a, -1);
    }
  }, {
    name: '28 反应级数 n=1/4',
    integ: function integ(a) {
      return 1 - Math.pow(1 - a, 1 / 4);
    },
    diff: function diff(a) {
      return 4 * Math.pow(1 - a, 3 / 4);
    }
  }, {
    name: '29 收缩球状体 n=1/3',
    integ: function integ(a) {
      return 1.0 - Math.pow(1 - a, 1 / 3.0);
    },
    diff: function diff(a) {
      return 3.0 * Math.pow(1 - a, 2 / 3.0);
    }
  }, {
    name: '30 收缩球状体 n=3',
    integ: function integ(a) {
      var pow = Math.pow(1 - a, 1.0 / 3.0);
      return 3.0 * (1.0 - pow);
    },
    diff: function diff(a) {
      return Math.pow(1 - a, 2.0 / 3.0);
    }
  }, {
    name: '31 收缩园柱体 n=1/2',
    integ: function integ(a) {
      return 1 - Math.pow(1 - a, 1 / 2);
    },
    diff: function diff(a) {
      return 2 * Math.pow(1 - a, 1 / 2.0);
    }
  }, {
    name: '32 收缩园柱体 n=2',
    integ: function integ(a) {
      return 2 * (1 - Math.pow(1 - a, 1.0 / 2.0));
    },
    diff: function diff(a) {
      return Math.pow(1 - a, 1.0 / 2.0);
    }
  }, {
    name: '33 反应级数 n=2',
    integ: function integ(a) {
      return 1.0 - Math.pow(1 - a, 2);
    },
    diff: function diff(a) {
      return 0.5 * Math.pow(1 - a, -1.0);
    }
  }, {
    name: '34 反应级数 n=3',
    integ: function integ(a) {
      return 1.0 - Math.pow(1 - a, 3);
    },
    diff: function diff(a) {
      return Math.pow(1 - a, -2) / 3.0;
    }
  }, {
    name: '35 反应级数 n=4',
    integ: function integ(a) {
      return 1 - Math.pow(1 - a, 4);
    },
    diff: function diff(a) {
      return Math.pow(1 - a, -3.0) / 4.0;
    }
  }, {
    name: '36 二级 化学反应',
    integ: function integ(a) {
      return Math.pow(1 - a, -1);
    },
    diff: function diff(a) {
      return Math.pow(1 - a, 2.0);
    }
  }, {
    name: '37 反应级数 化学反应',
    integ: function integ(a) {
      return Math.pow(1 - a, -1) - 1;
    },
    diff: function diff(a) {
      return Math.pow(1 - a, 2);
    }
  }, {
    name: '38 2/3级 化学反应',
    integ: function integ(a) {
      return Math.pow(1 - a, -1 / 2);
    },
    diff: function diff(a) {
      return 2 * Math.pow(1 - a, 3.0 / 2.0);
    }
  }, {
    name: '39 指数法则 n=1',
    integ: function integ(a) {
      return Math.log(a);
    },
    diff: function diff(a) {
      return a;
    }
  }, {
    name: '40 指数法则 n=2',
    integ: function integ(a) {
      return Math.log(Math.pow(a, 2));
    },
    diff: function diff(a) {
      return a / 2.0;
    }
  }, {
    name: '41 三级 化学反应',
    integ: function integ(a) {
      return Math.pow(1 - a, -2);
    },
    diff: function diff(a) {
      return Math.pow(1 - a, 3) / 2.0;
    }
  }, {
    name: '42 S-B方程',
    integ: function integ(a, m, n) {
      return a;
    },
    diff: function diff(a, m, n) {
      return Math.pow(a, m) * Math.pow(1 - a, n);
    }
  }, {
    name: '43 反应级数 化学反应',
    integ: function integ(a, m, n) {
      var temp = 1 - n;
      return (1 - Math.pow(1 - a, temp)) / temp;
    },
    diff: function diff(a, m, n) {
      return Math.pow(1 - a, n);
    }
  }, {
    name: '44 J-M-A方程',
    integ: function integ(a, m, n) {
      return Math.pow(-Math.log(1 - a), 1 / n);
    },
    diff: function diff(a, m, n) {
      var temp = 1 - a;
      return n * temp * Math.pow(-Math.log(temp), 1 - 1 / n);
    }
  }, {
    name: '45 幂函数法则',
    integ: function integ(a, m, n) {
      return Math.pow(a, 1 / n);
    },
    diff: function diff(a, m, n) {
      return n * Math.pow(a, (n - 1) / n);
    }
  }],
  default_high_charts_option: {
    title: {
      text: null
    },
    subtitle: {
      text: null
    },
    credits: {
      enabled: false
    },
    xAxis: {
      title: {
        text: null
      }
    },
    yAxis: {
      title: {
        text: null
      }
    },
    series: []
  }
});

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_iview_dist_styles_iview_css__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_iview_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_store__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_highcharts__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_highcharts__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_highcharts_modules_exporting__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_highcharts_modules_exporting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_highcharts_modules_exporting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_highcharts_modules_offline_exporting__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_highcharts_modules_offline_exporting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_highcharts_modules_offline_exporting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_highcharts_modules_export_data__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_highcharts_modules_export_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_highcharts_modules_export_data__);














__WEBPACK_IMPORTED_MODULE_7_highcharts_modules_exporting___default()(__WEBPACK_IMPORTED_MODULE_6_highcharts___default.a);
__WEBPACK_IMPORTED_MODULE_8_highcharts_modules_offline_exporting___default()(__WEBPACK_IMPORTED_MODULE_6_highcharts___default.a);
__WEBPACK_IMPORTED_MODULE_9_highcharts_modules_export_data___default()(__WEBPACK_IMPORTED_MODULE_6_highcharts___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_highcharts__["a" /* default */], { Highcharts: __WEBPACK_IMPORTED_MODULE_6_highcharts___default.a });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_iview___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__components_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ })

},[60]);


// WEBPACK FOOTER //
// static/js/app.ce282ed1bdee97f4dfb6.js